import type { Product } from './product'
import { productGraphQlFragment } from './product'

export interface ProductSearchResults {
  data: {
    search: {
      edges: [
        {
          node: Product
        },
      ]
    }
  }
}

export async function loadProductSearchResults(
  query: string,
): Promise<ProductSearchResults> {
  const res = await fetch(
    `https://${import.meta.env.VITE_SHOPIFY_STORE}.myshopify.com/api/2022-10/graphql.json`,
    {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': import.meta.env
          .VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `query searchProducts($query: String!, $first: Int) {
          search(query: $query, first: $first, types: PRODUCT) {
            edges {
              node {
                ... on Product {
                  ${productGraphQlFragment}
                }
              }
            }
          }
        }`,
        variables: {
          query,
          first: 10,
        },
      }),
    },
  )
  return await res.json()
}
